module.exports = __webpack_public_path__ + "static/media/share-icon1.77a5d250.svg";